import React, { useState, useContext, useEffect, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  AttachMoney,
  Search,
  Link,
  RadioButtonUnchecked,
  CheckCircle,
  FileDownload,
  RemoveOutlined,
} from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import {
  TextField,
  Box,
  Snackbar,
  Grid,
  Alert,
  Typography,
} from "@mui/material";
import Moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";

import StatusAdmin from "views/dialog/StatusAdmin";
import EditClientAdmin from "views/dialog/EditClientAdmin";
import ViewstrasactionsAdmin from "views/dialog/ViewstrasactionsAdmin";
import ViewsInvoicesAdmin from "views/dialog/ViewsInvoicesAdmin";
import LoadUserProfile from "components/services/LoadUserProfile";
import ViewExcelDownload from "views/dialog/ViewExcelDownload";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonTableGrid2,
  ButtonTableGrid1,
  ButtonTableGrid3,
  ButtonTableGrid4,
  ButtonTableGrid5,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const infoStyle = {
  color: "#1d1d1b",
  fontSize: 10,
  fontWeight: "bold",
  margin: "3px 0",
  borderBottom: "1px solid #f2f2f2",
  paddingLeft: 2,
  padding: "2px 5px 2px 15px",
};

export default function TransactionsAdmin() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [openExcel, setOpenExcel] = useState(false);
  const [openViewsInvoices, setOpenViewsInvoices] = useState(false);
  const [rows, setRows] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [openViewsTransactions, setOpenViewsTransactions] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);
  const [openSnackbar, setOpenSnackbar] = React.useState({
    mensage: "",
    open: false,
  });

  const { urlServices, urlWeb, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    userData: "",
  });

  const [state] = useState({
    columns: [
      {
        headerName: "COD.",
        field: "code",
        width: 60,
        headerAlign: "center",
        align: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <Alert severity="info" icon={false}>
              <b style={{ fontSize: 10 }}>{params.value} </b>
            </Alert>
          );
        },
        sortable: false,
        hideable: false,
      },
      ...(UserAuth.profile_id === 2
        ? [
            {
              headerName: "Gestor",
              field: "user",
              flex: 1,
              headerAlign: "center",
              headerClassName: "super-app-theme--header",
              cellClassName: (params) => {
                return clsx("super-app", {
                  celAll: params.value,
                });
              },
              renderCell: (params) => {
                return (
                  <div style={{ whiteSpace: "normal" }}>
                    {renderProfile(params.row)}
                  </div>
                );
              },
              sortable: false,
              hideable: false,
            },
          ]
        : []),
      {
        headerName: "Cliente",
        field: "client.allNames",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>{params.row.client.allNames} </b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        flex: 1,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        field: "action1",
        headerName: "----",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 140,
        align: "center",
        renderCell: (params) => (
          <ButtonTableGrid1
            onClick={openViewsTransactionsValue(params)}
            style={{ margin: "12px 0", fontSize: 10, width: "100%" }}
          >
            Ver transacción
          </ButtonTableGrid1>
        ),
      },
      {
        headerName: "---",
        field: "slug",
        headerClassName: "super-app-theme--header",
        width: 150,
        headerAlign: "center",
        renderCell: (params) => {
          const typePay =
            Array.isArray(params.row.productsJson) &&
            params.row.productsJson.length > 0
              ? params.row.productsJson[0]?.typePay
              : null;

          let pay = params.row.paymentTransactions.some(
            (transaction) => transaction.status === 1
          );

          let payInfo = null;

          if (!pay) {
            payInfo = params.row.paymentTransactions.some(
              (transaction) => transaction.status === 3
            );
          }
          const numeroCliente = params.row.client.phone;
          const codigoPais = params.row.client.prefix
            ? params.row.client.prefix.prefix
            : null; // Código de país para Ecuador
          return (
            <>
              {params.row.status !== 0 ? (
                pay || params.row.cashPaymentTransactions.length > 0 ? (
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{ display: typePay === "CR" ? "block" : "none" }}
                    >
                      <CopyToClipboard
                        text={`${urlWeb}addcard?transaction=${params.value}`}
                        onCopy={handleCopy}
                      >
                        <ButtonTableGrid2
                          startIcon={<Link />}
                          style={{
                            marginTop: 10,
                            padding: "3px 3px",
                            width: "100%",
                          }}
                        >
                          Link tarjetas
                        </ButtonTableGrid2>
                      </CopyToClipboard>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <ButtonTableGrid3
                        style={{
                          margin: "6px 0 2px 0",
                          padding: "4px 10px",
                          width: "100%",
                        }}
                        onClick={handleValueClientCert(params)}
                      >
                        Enviar Certificado
                      </ButtonTableGrid3>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <ButtonTableGrid5
                        style={{
                          margin: "2px 0 2px 0",
                          padding: "4px 10px",
                          width: "100%",
                        }}
                        onClick={() => {
                          const numeroFormateado = numeroCliente
                            ? `+${codigoPais}${numeroCliente.replace(
                                /\D/g,
                                ""
                              )}`
                            : null; // Elimina caracteres no numéricos
                          // Abre el chat de WhatsApp en una nueva pestaña
                          window.open(
                            `https://wa.me/${numeroFormateado}`,
                            "_blank"
                          );
                        }}
                        disabled={
                          numeroCliente && numeroCliente !== "" ? false : true
                        }
                      >
                        WhatsApp
                      </ButtonTableGrid5>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{
                        display:
                          params.row.invoiceHistory &&
                          params.row.invoiceHistory.length > 0
                            ? "block"
                            : "none",
                      }}
                    >
                      <ButtonTableGrid4
                        style={{
                          margin: "2px 0 8px 0",
                          padding: "4px 10px",
                          width: "100%",
                        }}
                        onClick={openViewsInvoicesValue(params)}
                      >
                        Ver factura
                      </ButtonTableGrid4>
                    </Grid>
                  </Grid>
                ) : payInfo ? (
                  <Alert
                    icon={false}
                    severity="error"
                    sx={{ fontSize: 10, fontWeight: "bold" }}
                  >
                    PENDIENTE
                  </Alert>
                ) : (
                  <Grid container>
                    <Grid item xs={12} sm={12}>
                      {typePay === "CR" ? (
                        <CopyToClipboard
                          text={`${urlWeb}addcard?transaction=${params.value}`}
                          onCopy={handleCopy}
                        >
                          <ButtonTableGrid2
                            startIcon={<Link />}
                            style={{
                              margin: "12px 0 1px 0",
                              padding: "3px 3px",
                              width: "100%",
                              backgroundColor:
                                params.row.paymentTransactions.some(
                                  (transaction) => transaction.status === 1
                                )
                                  ? "#ccc"
                                  : "",
                            }}
                          >
                            Link tarjetas
                          </ButtonTableGrid2>
                        </CopyToClipboard>
                      ) : (
                        <CopyToClipboard
                          text={`${urlWeb}payment?transaction=${params.value}`}
                          onCopy={handleCopy}
                        >
                          <ButtonTableGrid2
                            startIcon={<Link />}
                            style={{
                              margin: "12px 0 1px 0",
                              padding: "3px 10px",
                              width: "100%",
                              backgroundColor:
                                params.row.paymentTransactions.some(
                                  (transaction) => transaction.status === 1
                                )
                                  ? "#ccc"
                                  : "",
                            }}
                          >
                            Link pago
                          </ButtonTableGrid2>
                        </CopyToClipboard>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <ButtonTableGrid5
                        style={{
                          margin: "2px 0 8px 0",
                          padding: "4px 10px",
                          width: "100%",
                        }}
                        onClick={() => {
                          const numeroFormateado = numeroCliente
                            ? `+${codigoPais}${numeroCliente.replace(
                                /\D/g,
                                ""
                              )}`
                            : null; // Elimina caracteres no numéricos
                          // Abre el chat de WhatsApp en una nueva pestaña
                          window.open(
                            `https://wa.me/${numeroFormateado}`,
                            "_blank"
                          );
                        }}
                        disabled={
                          numeroCliente && numeroCliente !== "" ? false : true
                        }
                      >
                        WhatsApp
                      </ButtonTableGrid5>
                    </Grid>
                  </Grid>
                )
              ) : (
                <Alert
                  icon={false}
                  severity="error"
                  sx={{ fontSize: 10, fontWeight: "bold" }}
                >
                  Cancelado
                </Alert>
              )}
            </>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "COBRO",
        field: "status0",
        headerAlign: "center",
        width: 70,
        align: "center",
        headerClassName: "super-app-theme--header-mayuscula",
        renderCell: (params) => {
          return (
            <>
              <b style={{ fontSize: 10, textAlign: "center" }}>
                {params.row.productsJson[0].typePay === "TC"
                  ? "TARJETA DE CRÉDITO"
                  : params.row.productsJson[0].typePay === "E"
                  ? "EFECTIVO"
                  : "COBRO RECURRENTE"}
              </b>
            </>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "TERMINOS",
        field: "status",
        headerAlign: "center",
        width: 70,
        align: "center",
        headerClassName: "super-app-theme--header-mayuscula",
        renderCell: (params) => {
          const cardRegister =
            Array.isArray(params.row.client?.cardCollection) &&
            params.row.client?.cardCollection.length > 0;
          return (
            <>
              {(params.row.acceptTerms ||
                params.row.cashPaymentTransactions.length > 0 ||
                cardRegister) &&
              params.row.status !== 0 ? (
                <CheckCircle
                  sx={{
                    fontSize: 22,
                    marginLeft: 1,
                    color: "green",
                    verticalAlign: "middle",
                  }}
                />
              ) : (
                <RadioButtonUnchecked
                  sx={{
                    fontSize: 22,
                    marginLeft: 1,
                    color: params.row.status !== 0 ? "red" : "#CCC",
                    verticalAlign: "middle",
                  }}
                />
              )}
            </>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "PAGO",
        field: "status1",
        headerAlign: "center",
        width: 70,
        align: "center",
        headerClassName: "super-app-theme--header-mayuscula",
        renderCell: (params) => {
          let pay = params.row.paymentTransactions.some(
            (transaction) => transaction.status === 1
          );

          const typePayCR =
            params.row.productsJson[0].typePay === "CR" ? true : false;
          return (
            <>
              {(pay || params.row.cashPaymentTransactions.length > 0) &&
              params.row.status !== 0 ? (
                <CheckCircle
                  sx={{
                    fontSize: 22,
                    color: "green",
                    verticalAlign: "middle",
                  }}
                />
              ) : typePayCR ? (
                <RemoveOutlined />
              ) : (
                <RadioButtonUnchecked
                  sx={{
                    fontSize: 22,
                    marginLeft: 1,
                    color: params.row.status !== 0 ? "red" : "#CCC",
                    verticalAlign: "middle",
                  }}
                />
              )}
            </>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  const renderProfile = (row) => (
    <>
      <Typography sx={infoStyle} style={{ fontSize: 12 }}>
        {row.user.allNames}
      </Typography>
      <Typography sx={infoStyle} style={{ fontWeight: 500 }}>
        ({row.user.profile.name})
      </Typography>
    </>
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable();
  }, []);

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleSearchChange = (event) => {
    const value = event.target.value; // Obtener el valor del input
    setSearchText(value); // Actualizar el estado del texto de búsqueda

    // Filtrar los datos según el valor de búsqueda
    if (value.trim() !== "") {
      const resultSearch = rowsResponse.filter(
        (item) =>
          removeAccents(item.user.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          removeAccents(item.client.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          item.code.toString().includes(value)
      );
      setRows(resultSearch);
    } else {
      setRows(rowsResponse); // Restaurar los datos originales si no hay búsqueda
    }
  };

  const RefreshTable = async () => {
    setSearchText("");
    setLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}clients-transaction/list/company`,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        const transformedRows = response.data.map((data) => ({
          ...data,
          client: {
            ...data.client, // Si necesitas otras propiedades de client
            prefix: JSON.parse(data.client.prefix), // Asigna prefix directamente
          },
          productsJson: parseJsonArray(data.productsJson),
          dependentsJson: parseJsonArray(data.dependentsJson),
          detailsCancel: data.detailsCancel
            ? JSON.parse(data.detailsCancel)
            : null,
        }));

        setRows(transformedRows);
        setRowsResponse(transformedRows);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const handleCopy = () => {
    setOpenSnackbar({ mensage: "Link copiado al portapapeles!", open: true });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar({ open: false });
  };

  const handleValueClientCert = (data) => async () => {
    // Filtramos
    let dataValue = {};
    let URL = "";

    if (
      data.row.paymentTransactions &&
      data.row.paymentTransactions.length > 0 &&
      data.row.productsJson[0].typePay !== "CR"
    ) {
      let dataReponse = "";
      const responseData = data.row.paymentTransactions.filter(
        (transactions) => transactions.status === 1
      );

      if (responseData.length > 0) {
        dataReponse = JSON.parse(responseData[0].responseTransaction);
      }

      setError(false);

      dataValue = {
        dataTransaction: data.row,
        paytransaction: dataReponse,
      };

      URL = "payment-transaction/certificate";
    } else {
      // console.log("ENTROOO: ", data.row);
      // console.log("ENTROOO2: ", data.row.productsJson[0].typePay);
      let dateCR = null;

      if (data.row.productsJson[0].typePay === "CR") {
        // Buscar la transacción más antigua con status 1
        const status1Transactions = data.row.paymentTransactions
          .filter((transaction) => transaction.status === 1)
          .sort((a, b) => a.id - b.id);

        dateCR = status1Transactions.length > 0 ? status1Transactions[0] : null;
      }

      const clients = {
        id: data.row.clientsId,
        client: data.row.client,
        user: data.row.user,
        productsJson: JSON.stringify(data.row.productsJson),
        validation: data.row.productsJson[0].typePay !== "CR" ? 1 : 2,
        dateCreated:
          data.row.productsJson[0].typePay !== "CR"
            ? Moment(data.row.cashPaymentTransactions[0].createdAt)
            : dateCR
            ? Moment(dateCR.createdAt)
            : Moment(),
      };

      dataValue = {
        clients: clients,
      };

      URL = "clients-transaction/certificate-cash";
    }

    try {
      const response = await axios.post(`${urlServices}${URL}`, dataValue);
      if (response.status === 200) {
        setOpenSnackbar({
          mensage: "Certificado enviado al correo del cliente",
          open: true,
        });
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  const openViewsTransactionsValue = (data) => () => {
    setIdRow(data);
    setOpenViewsTransactions(true);
  };

  const openViewsInvoicesValue = (data) => () => {
    setIdRow({ data: data.row });
    setOpenViewsInvoices(true);
  };

  const changeUserProfile = (data) => {
    setValues((prevValues) => ({
      ...prevValues,
      userData: data || null,
    }));

    const filteredRows = data
      ? rowsResponse.filter((item) => item.userId === data.id)
      : rowsResponse;

    setRows(filteredRows);
  };

  const openExcelValue = () => () => {
    setOpenExcel(true);
  };

  const handleCloseExcel = () => {
    setOpenExcel(false);
  };

  const handleCloseViewsInvoices = () => {
    setOpenViewsInvoices(false);
  };

  const handleCloseViewsDependents = () => setOpenViewsTransactions(false);
  const handleCloseStatus = () => setOpenStatus(false);
  const handleCloseEdit = () => setOpenEdit(false);

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.cardTitleBlack}>
          <AttachMoney className={classes.iconFilter} /> Listado de
          transacciones
        </div>
        <Card>
          <CardBody>
            {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "20% 0" }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    {/* Campo de búsqueda */}
                    <TextField
                      variant="outlined"
                      value={searchText}
                      onChange={handleSearchChange}
                      sx={{ mt: 1, mb: 2 }}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <Search
                            position="start"
                            style={{
                              color: "gray",
                              fontSize: 22,
                              marginRight: 10,
                            }}
                          />
                        ),
                      }}
                      fullWidth
                      placeholder="Buscar"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    sx={{
                      display: UserAuth.profile_id === 2 ? "block" : "none",
                    }}
                  >
                    <LoadUserProfile
                      value={values.userData}
                      refresh={changeUserProfile}
                      style={{ marginBottom: 2 }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={UserAuth.profile_id === 2 ? 4 : 8}
                    sx={{ marginTop: 2 }}
                  >
                    <ButtonTableGrid1
                      onClick={openExcelValue()}
                      style={{ backgroundColor: "green", float: "right" }}
                      startIcon={<FileDownload style={{ fontSize: 14 }} />}
                    >
                      Excel
                    </ButtonTableGrid1>
                  </Grid>
                </Grid>
                <Grid container>
                  {rows.length > 0 ? (
                    <Grid item xs={12} sm={12}>
                      <Box
                        sx={{
                          "& .super-app.celAll": {
                            fontSize: 12,
                            //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                          },
                          "& .super-app.celActions": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          "& .super-app-theme--header": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          "& .super-app-theme--header-mayuscula": {
                            backgroundColor: "rgb(242, 242, 242)",
                            fontSize: 10,
                          },
                          marginTop: 2,
                        }}
                      >
                        <DataGrid
                          rows={rows}
                          columns={state.columns}
                          loading={loader}
                          initialState={{
                            pagination: {
                              paginationModel: { page: 0, pageSize: 10 },
                            },
                          }}
                          pageSizeOptions={[5, 10, 20, 50]}
                          disableRowSelectionOnClick={true}
                          checkboxSelection={false}
                          sx={{
                            [`& .${gridClasses.cell}`]: {
                              display: "flex",
                              alignItems: "center", // Alineación vertical
                              // justifyContent: 'center', // Alineación horizontal
                              wordWrap: "break-word !important",
                              whiteSpace: "normal !important",
                            },
                            /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                          }}
                          getRowHeight={() => "auto"}
                          // autoHeights
                          autoWidth
                        />
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={12}>
                      <center>
                        <img
                          alt="loaderGif"
                          src={noDataImg}
                          style={{ width: 300, marginTop: 50 }}
                        />
                        <br></br>
                        <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                          No hay registros para mostrar
                        </b>
                      </center>
                    </Grid>
                  )}
                </Grid>
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
      {openStatus && (
        <StatusAdmin
          open={openStatus}
          exit={handleCloseStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
          path="clients"
        />
      )}
      {openEdit && (
        <EditClientAdmin
          open={openEdit}
          exit={handleCloseEdit}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openViewsTransactions && (
        <ViewstrasactionsAdmin
          open={openViewsTransactions}
          exit={handleCloseViewsDependents}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openViewsInvoices && (
        <ViewsInvoicesAdmin
          open={openViewsInvoices}
          exit={handleCloseViewsInvoices}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openExcel && (
        <ViewExcelDownload
          open={openExcel}
          id={rows}
          exit={handleCloseExcel}
          title="Se descargará el listado de transacciones actual."
        />
      )}
      <Snackbar
        open={openSnackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
        >
          {openSnackbar.mensage}
        </Alert>
      </Snackbar>
    </GridContainer>
  );
}
